import React from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { useLocation } from "react-router-dom";

function BackButton() {
  const location = useLocation();

  const handleBack = (event) => {
    // Prevent any default behavior
    event.preventDefault();
    event.stopPropagation();
    
    console.log("Back button clicked from:", location.pathname);
    console.log("History length:", window.history.length);
    
    // Try multiple methods to go back
    setTimeout(() => {
      try {
        // Method 1: Use history.back()
        console.log("Trying window.history.back()");
        window.history.back();
      } catch (error) {
        console.error("Method 1 failed:", error);
        
        // Method 2: Use history.go(-1)
        try {
          console.log("Trying window.history.go(-1)");
          window.history.go(-1);
        } catch (error2) {
          console.error("Method 2 failed:", error2);
          
          // Method 3: Force navigation
          console.log("Forcing navigation to top plans");
          window.location.replace('/dashboard/top-plans');
        }
      }
    }, 100); // Small delay to ensure event handling is complete
  };

  // Don't show back button on home page
  if (location.pathname === "/" || location.pathname === "/home") {
    return null;
  }

  return (
    <Tooltip title="Go back">
      <Button
        type="text"
        icon={<ArrowLeftOutlined />}
        onClick={handleBack}
        className="th-pri-hover"
        style={{ marginRight: "8px" }}
      />
    </Tooltip>
  );
}

export default BackButton;